import { globalStyleSheet } from "@/assets/css/global";
import menuIcon from '@/assets/images/menu.svg';
const styleSheet = new CSSStyleSheet();
styleSheet.replaceSync(`
    :host {
        --size: 30px;
        display: flex;
        width: var(--size);
        min-width: var(--size);
        aspect-ratio: 1;
        height: var(--size);
        border-radius: 6px;
        overflow: hidden;
    j   justify-content: flex-end;
    }
    
    button {
        background-image: url(${menuIcon});
        background-repeat: no-repeat;
        background-position: center;
        background-size: 20px;
        height: 100%;
        width: 100%;
        border-radius: 6px;
        border-color: transparent;
        background-color: gray;
      }
`);
export class RMenuButton extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' }).adoptedStyleSheets = [globalStyleSheet, styleSheet];
    }
    connectedCallback() {
        this.#initDOM();
    }
    #initDOM() {
        this.shadowRoot.innerHTML = `
            <button>
            </button>
        `;
    }
}
customElements.define('r-menu-button', RMenuButton);
